import { getRequest, postRequest } from 'helpers/axios';

// Check if user is eligible for lifetime subscription
export const checkLifetimeEligibility = async () => {
  try {
    const response = await getRequest(
      'lifetime_subscriptions/check_eligibility',
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Get available lifetime plans
export const getAvailableLifetimePlans = async () => {
  try {
    const response = await getRequest('lifetime_subscriptions/available_plans');
    return response;
  } catch (error) {
    throw error;
  }
};

// Create payment intent for lifetime subscription
export const createLifetimePaymentIntent = async (lifetimePriceId = null, couponCode = null, discountedPrice = null) => {
  try {
    const body = {};
    if (lifetimePriceId) body.lifetime_price_id = lifetimePriceId;
    if (couponCode) body.coupon_code = couponCode;
    if (discountedPrice) body.discounted_price = discountedPrice;

    const response = await postRequest(
      'lifetime_subscriptions/create_payment_intent',
      body,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Confirm payment and activate lifetime subscription
export const confirmLifetimePayment = async (paymentIntentId) => {
  try {
    const response = await postRequest(
      'lifetime_subscriptions/confirm_payment',
      {
        payment_intent_id: paymentIntentId,
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
